<template>
  <div class="invoicerow"> 
    <div class="column">
      <user-icon size="1.5x" class="custom-class"></user-icon>
      <p class="user" :title="name">{{ name }}</p>
    </div>
    <div v-if="!isMobile()" class="column date">
      <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
      <p>{{ humanTime(ctime) }}</p>
    </div>
    <div v-if="!isMobile()" class="column buttons">
      <button class="button default" :class="{'activo': handleCuentaDefecto === handle}" :title="$t('settings.defaultAccount')" :disabled="handleCuentaDefecto === handle" @click="añadirCuentaPorDefecto(handle)">
        <span>{{ $t('settings.defaultAccount') }}</span>
      </button>
      <button v-if="handleCuenta !== handle" class="button button-create signup" :title="$t('login.submit')" @click="show(handle)">
        <span>{{ $t('login.submit') }}</span>
      </button>
      <span v-else class="admin">{{ $t('settings.currentAccount') }}</span>
    </div>
    <div v-if="isMobile()" class="column info">
      <button @click="isShow = true" :aria-label="$t('buttons.moreInformation')" :title="$t('buttons.moreInformation')" class="action" id="info-button">
        <info-icon size="1.5x" class="custom-class"></info-icon>
      </button>
      <div class="information" :style="infoStyle">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <h3>{{ $t('settings.accountInformation') }}</h3>
          <x-icon @click="isShow = false" size="1.5x" class="custom-class"></x-icon>
        </div>
        <div class="column">
          <user-icon size="1.5x" class="custom-class"></user-icon>
          <p class="user" :title="name">{{ name }}</p>
        </div>
        <div class="column date">
          <calendar-icon size="1.5x" class="custom-class"></calendar-icon>
          <p>{{ humanTime(ctime) }}</p>
        </div>
        <div class="column buttons">
          <button class="button default" :class="{'activo': handleCuentaDefecto === handle}" :title="$t('settings.defaultAccount')" :disabled="handleCuentaDefecto === handle" @click="añadirCuentaPorDefecto(handle)">
            <span>{{ $t('settings.defaultAccount') }}</span>
          </button>
          <button v-if="handleCuenta !== handle" class="button button-create signup" :title="$t('login.submit')" @click="show(handle)">
            <span>{{ $t('login.submit') }}</span>
          </button>
          <span v-else class="admin">{{ $t('settings.currentAccount') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { UserIcon, CalendarIcon, XIcon, InfoIcon  } from 'vue-feather-icons';
import { files as ibbapi } from '@/api';
import { mapMutations } from 'vuex';

export default {
  name: 'accounts',
  components: {
    UserIcon,
    CalendarIcon,
    XIcon,
    InfoIcon
  },
  data: function () {
    return {
      isShow: false,
      handleCuenta: ''
    };
  },
  props: ['name', 'ctime', 'handle', 'handleCuentaDefecto'],
  async mounted () {
    try {
      let action = await ibbapi.getAccountInfo();
      this.handleCuenta = action.accountInfo.handle;
    } catch (e) {
      this.$showError(e);
    }
  },
  computed: {
    infoStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    ...mapMutations([ 'setAccountHandle' ]),
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    humanTime: function (time) {
      if (time === 0) {
        return '-';
      } else {
        return moment(time * 1000).format('DD/MM/YYYY');
      }
    },
    añadirCuentaPorDefecto(handle) {
      this.$emit('cuenta-defecto', handle);
    },
    show (handle) {
      this.$store.commit('setAccountHandle', handle);
      this.$store.commit('showHover', 'logout');
    },
  }
};
</script>